<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="13">
                <el-row>
                    <el-col>
                        <div class="spreadsheet-header-title">
                            {{ title }}
                        </div>
                        <div class="spreadsheet-header-filter-info">
                            <span class="spreadsheet-header-filter-info_black">
                                Поиск по:
                            </span>
                            <span class="spreadsheet-header-filter-info_gray">
                                {{ query }}
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <span class="spreadsheet-header-filter-info_black">
                            Всего найдено:
                        </span>
                        <span class="spreadsheet-header-filter-info_gray">
                            {{ totalItems }}
                        </span>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="3">
                <el-button class="spreadsheet-header-button" type="warning" @click="closeSearch()">
                    Закрыть
                </el-button>
            </el-col>
        </el-row>
        <el-row type="flex" align="top" class="spreadsheet-table" v-loading="loading">
            <el-col :span="24">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                    :framework-components="frameworkComponents"
                />
            </el-col>
        </el-row>
        <el-row type="flex" align="bottom" class="spreadsheet-bar">
            <el-col :span="6">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalItems"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :small="true"
                    @current-change="getCurrentPage"
                />
            </el-col>
            <el-col :span="10">
                <div class="spreadsheet-bar-pages">
                    <span class="spreadsheet-bar-pages-title">
                        Выводить по:
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize20}"
                        @click="setPageSize(20)"
                    >
                        20
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize50}"
                        @click="setPageSize(50)"
                    >
                        50
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize100}"
                        @click="setPageSize(100)"
                    >
                        100
                    </span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="spreadsheet-bar-total">
                    <span>
                        Строк выведено: {{ totalRows }} Из них выделено: {{ selectedRowsCount }}
                    </span>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import TableHeaderSettings from '@/components/TableHeaderSettings';
import TableHeaderMessages from '@/components/TableHeaderMessages';
import LeadTarget from '@/components/gridComponents/LeadTarget';
import { pickerOptions } from '@/common/pickerOptions';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import capitalize from 'lodash/capitalize';
import '@/assets/styles/list.scss';
import { viewCustomFields } from '@/common/utilities';

library.add(faEye);

export default {
    name: 'LeadsGrid',
    props: {
        query: {
            type: [String],
            default: null
        }
    },
    data() {
        return {
            title: 'Лиды. Результат поиска',
            isSearchVisible: false,
            totalItems: 0,
            fieldsNames: {
                id: 'id лида',
                created_at: 'Дата',
                unread: 'Есть непрочитанное сообщение',
                status: 'Статус',
                officeName: 'Офис',
                responsibleUser: 'Ответственный',
                contactName: 'Имя контакта',
                contactPhone: 'Телефон контакта',
                contactEmail: 'E-mail контакта',
                link: 'Канал связи',
                address: 'Адрес',
                title: 'Название',
                custom_fields: 'Дополнительные поля'
            },
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            formLabelWidth: '120px',
            totalRows: 0,
            selectedRowsCount: 0,
            loading: true,
            pickerOptions,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onRowDataChanged: this.onRowDataChanged.bind(this),
                onRowSelected: this.onRowSelected.bind(this),
                onRowDoubleClicked: this.onSelectionChanged.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                }
            },
            columnDefs: [],
            employerOptions: [],
            statusNew: 1,
            statusTarget: 2,
            statusNotTarget: 3,
            frameworkComponents: null
        };
    },
    components: {
        'ag-grid-vue': AgGridVue
    },
    computed: {
        leads() {
            return this.$store.state.leads.leads;
        },
        unreadCount() {
            return this.$store.state.leads.unreadCount;
        },
        pagesInfo() {
            return this.$store.state.leads.pages;
        },
        employers() {
            return this.$store.state.references.employers;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        statusOptions() {
            return this.$store.state.references.leadStatuses;
        },
        linkOptions() {
            return this.$store.state.references.leadLinks;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field]) {
                    const getNamesFrom = (obj) => {
                        if (Object.keys(obj).length !== 0) {
                            return (this.fieldsNames[field] + ': ' + this.filterModel[field].map(id => obj.find(item => item.id === id).name).join(' | ') + '; ');
                        } else {
                            return '';
                        }
                    };
                    if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                        switch (field) {
                            case 'status':
                                result += getNamesFrom(this.statusOptions);
                                break;
                            case 'link':
                                result += getNamesFrom(this.linkOptions);
                                break;
                            case 'created_at':
                                result += this.fieldsNames[field] + ': ' +
                                    'с ' + this.filterModel[field][0] +
                                    ' по ' + this.filterModel[field][1] + '; ';
                                break;
                            default:
                                result += (this.fieldsNames[field] + ': ' + this.filterModel[field] + '; ');
                        }
                    }
                    if (field === 'unread') {
                        result += this.fieldsNames[field] + '; ';
                    }
                }
            }
            return result;
        }
    },
    created() {
        this.frameworkComponents = {
            leadTarget: LeadTarget
        };
        this.columnDefs = [
            {
                headerName: this.capitalize(this.fieldsNames.id),
                field: 'id',
                cellRenderer: (params) => {
                    return this.getLinkElement(params.data.id, params.data.id, { name: 'lead-card', params: { id: params.data.id } }, 'a', 'spreadsheet-table-id-link');
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.unread),
                field: 'unread_messages',
                cellRenderer: (params) => {
                    let response = '';
                    if (params.data.unread_messages > 0) {
                        response = `<div class="flex-row-2col">
                                <div class="flex-column envelop"></div>
                                <div class="flex-column unread-msg">${params.data.unread_messages}</div>
                             </div>`;
                    }
                    return response;
                },
                headerComponentFramework: TableHeaderMessages,
                cellClass: null,
                width: 50
            },
            {
                headerName: this.capitalize(this.fieldsNames.created_at),
                field: 'created_at'
            },
            {
                headerName: this.fieldsNames.status,
                field: 'status.name',
                cellRenderer: ({ data }) => data.status ? `<div class="text-center lead-status-${data.status_id}">${data.status.name}</div>` : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.title),
                field: 'title'
            },
            {
                headerName: this.capitalize(this.fieldsNames.officeName),
                field: 'office.name'
            },
            {
                headerName: this.capitalize(this.fieldsNames.responsibleUser),
                field: 'responsible_user.full_name',
                cellRenderer: (params) => {
                    if (+params.data.responsible_user_id > 0) {
                        return params.data.responsible_user.full_name;
                    }
                    return null;
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.contactName),
                field: 'contact.name'
            },
            {
                headerName: this.capitalize(this.fieldsNames.contactPhone),
                field: 'contact.phone',
                cellRenderer: (params) => {
                    if (params.data.contact && params.data.contact.contact_phones) {
                        return params.data.contact.contact_phones.reduce((result, item) => result + item.phone + '; ', '').slice(0, -2);
                    }
                    return '';
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.contactEmail),
                field: 'contact.email'
            },
            {
                headerName: this.capitalize(this.fieldsNames.address),
                field: 'address'
            },
            {
                headerName: this.capitalize(this.fieldsNames.link),
                field: 'link.name'
            },
            {
                headerName: '',
                field: 'value',
                cellRenderer: 'leadTarget',
                width: 200
            },
            {
                headerName: this.capitalize(this.fieldsNames.custom_fields),
                field: 'custom_fields',
                width: 220,
                cellRenderer: ({ data }) => data.custom_fields ? viewCustomFields(data.custom_fields) : ''
            },
            {
                headerName: '',
                field: '',
                headerComponentFramework: TableHeaderSettings,
                cellRenderer: (params) => {
                    return this.getLinkElement(params.data.id, '', { name: 'lead-card', params: { id: params.data.id } }, 'div', 'cell-icon');
                },
                width: 40,
                cellClass: null
            }
        ];
    },
    mounted() {
        this.$store.dispatch('preferences/getPreferences').then(
            () => {
                this.setSettings();
            }).catch(() => {
            this.getDataFromServer();
        });
    },
    methods: {
        setSettings() {
            if (this.setting.leads) {
                this.gridOptions.columnApi.setColumnState(this.setting.leads.table);
                this.gridOptions.api.setSortModel(this.setting.leads.sort);
                this.resetContactFilter();
            } else {
                this.gridOptions.api.setSortModel({});
                this.getDataFromServer();
            }
        },
        getLinkElement(id, name, route, elementType, className) {
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
            }
            element.innerText = name;
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        onSelectionChanged(e) {
            this.$router.push({ name: 'lead-card', params: { id: '' + e.node.data.id } });
        },
        getDataFromServer() {
            const requestParams = {
                type: 'lead',
                query: this.query,
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage
            };
            this.loading = true;
            this.$store.dispatch('search/getPaginatedList', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(response.data.data.leads);
                    this.totalItems = response.data.data.lead.info.value;
                    this.loading = false;
                }).catch(
                error => {
                    console.log(error);
                });
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        onRowDataChanged() {
            this.totalRows = this.gridOptions.api.getDisplayedRowCount();
        },
        onRowSelected() {
            this.selectedRowsCount = this.gridOptions.api.getSelectedRows().length;
        },
        closeSearch() {
            this.$router.go(-1);
        },
        capitalize: capitalize
    }
};
</script>
